import { CandidateEvaluationFeedback } from '../candidateEvaluationFeedback';
import { ScheduleInterview } from '../scheduleInterview';


export class CandidateEvaluationFeedbackSerializer {
    fromJson(json: any): CandidateEvaluationFeedback {
        return json;
    }

    toJson(data: ScheduleInterview): any {
        return data
    }
}